var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Play",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9818375,8.73540678 L2.19086194,0.195737038 C1.73872404,-0.0652456793 1.1824863,-0.0652456793 0.729798581,0.195737038 C0.278393783,0.456536481 1.30224279e-15,0.939097924 1.30224279e-15,1.46088008 L1.30224279e-15,18.539853 C1.30224279e-15,19.0618184 0.278943606,19.5440133 0.729798581,19.8044462 C0.956325715,19.9351209 1.20814471,20 1.46033026,20 C1.71214926,20 1.96451808,19.9351209 2.19031212,19.8044462 L16.9812877,11.2649598 C17.4332423,11.0043436 17.7114551,10.5219654 17.7114551,10.0003665 C17.7123692,9.47876766 17.4336089,8.99657277 16.9818375,8.73540678 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.f0b2e1bd8ee8a890156a837b2c089ff6.svg";
export { ForwardRef as ReactComponent };